import React, {useState} from 'react';
import { Tag } from 'antd';
import Pedidolc from './pedidolc';
import BotonesPedidolc from './botonesPedidoslc';
import FiltrableProTable from '../../../shared/containers/FiltrableProTable';

export default function TablePedidoslc({ toolbar, data, total, page, pageSize, onPageChange, loading }) {

  const columnas = [
    {
      key: 'descripcion',
      title: 'Articulo',
      dataIndex: 'descripcion',
      hideInSetting: true,
    },
    {
      key: 'fecha_emision',
      title: 'Fecha de venta',
      dataIndex: 'fecha_emision',
    },
    {
      key: 'origen',
      title: 'Origen',
      dataIndex: 'origen',
      render: origen => (
        <div className="origen-pedidoslc">{origen}</div>
      ),
    },
    {
      key: 'tipo',
      title: 'Tipo',
      dataIndex: 'tipo',
      render: (tipo) => {
        let color = 'magenta';
        switch (tipo) {
          case 'VENTA':
            color = 'green';
            break;
          case 'PEDIDO':
            color = 'blue';
            break;
        }
        return (
          <Tag style={{ textTransform: 'capitalize' }} color={color}>{tipo.toLowerCase()}</Tag>
        );
      },
    },
  ];
  const renderTablaAnidada = (record) => {
    const { graduacion, id } = record;
    return (
      <div>
        <p><b>Parametros de la lente:</b></p>
        <div>
          <Pedidolc key={`parametros_pedidolc_${id}`} parametros={graduacion} />
        </div>
      </div>
    );
  };
  const pagination = {
    showSizeChanger: false,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize,
    total,
    current: page,
    onChange: (page) => {
      onPageChange(page);
    },
  };
  const renderToolbar = () => [
    toolbar,
  ];
  return (
    <FiltrableProTable
      columns={columnas}
      datasource={data}
      rowClick={() => {}}
      toolBarRender={() => renderToolbar()}
      pagination={pagination}
      expandedRowRender={renderTablaAnidada}
      loading={loading}
    />
  );
}
